import { ApiError } from '@/lib/api'
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { SheetSectionCard } from '@/components/SheetSectionCard'
import { useCallMessagesQuery } from '@/hooks/useCallMessagesQuery'
import { MessageThreadSheet } from '@/features/messages/components/MessageThreadSheet'
import { formatSheetTimestamp } from '@/lib/format'
import {
  MessageFailureDetails,
  MessageStatusLabel,
  messageBodyText,
} from '@/features/messages/components/MessageStatus'

export function CallTextsSection({ callId }: { callId: string }) {
  const { data, isLoading, isError, error } = useCallMessagesQuery(callId)
  const [phone, setPhone] = useState<string | null>(null)
  if (error instanceof ApiError && error.status === 403) return null
  return (
    <>
      <SheetSectionCard
        title="Texts"
        body={
          isLoading ? (
            <p className="text-muted-foreground text-sm">Loading texts…</p>
          ) : isError ? (
            <p className="text-destructive text-sm">
              Unable to load texts for this call.
            </p>
          ) : !data?.length ? (
            <p className="text-muted-foreground text-sm">
              No texts associated with this call.
            </p>
          ) : (
            <div className="space-y-3">
              {data.map((message) => (
                <div key={message.id} className="rounded-md border p-3">
                  <div className="text-muted-foreground mb-2 flex items-center gap-1 text-xs">
                    <MessageStatusLabel message={message} />
                    <span aria-hidden="true">{' · '}</span>
                    <time dateTime={message.created_at}>
                      {formatSheetTimestamp(message.created_at)}
                    </time>
                  </div>
                  <p className="whitespace-pre-wrap break-words text-sm">
                    {messageBodyText(message)}
                  </p>
                  <MessageFailureDetails message={message} />
                  <Button
                    variant="link"
                    className="mt-1 h-auto p-0"
                    onClick={() =>
                      setPhone(
                        message.direction === 'outbound'
                          ? message.to_phone_number
                          : message.from_phone_number
                      )
                    }>
                    View conversation
                  </Button>
                </div>
              ))}
            </div>
          )
        }
      />
      <MessageThreadSheet
        phone={phone}
        onOpenChange={(open) => {
          if (!open) setPhone(null)
        }}
      />
    </>
  )
}
